function addSpeculationRules(enrollmentUrl) {
  if (prerenderEnrollmentControl) {
    return;
  }

  const specScript = document.createElement('script');
  specScript.type = 'speculationrules';
  let specRules;
  if (prerenderEnrollmentImmediate) {
    specRules = {
      prerender: [
        {
          urls: [enrollmentUrl],
          eagerness: "immediate",
        },
        ],
      };
  } else if (prerenderEnrollmentModerate) {
    specRules = {
      prerender: [
        {
          urls: [enrollmentUrl],
          eagerness: "moderate",
        },
      ],
    };
  } else if (prerenderEnrollmentPrefetch) {
    specRules = {
      prefetch: [
        {
          urls: [enrollmentUrl],
        },
      ],
    };
  }

  specScript.textContent = JSON.stringify(specRules);
  document.body.append(specScript);
}
